import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { isFutureVersion } from '../services/access-validation.service';

/**
 * [CurveBeamAI] Redirect when launched from DMP with session_id + StudyInstanceUIDs.
 * User may land at / (worklist) instead of viewer; redirect to viewer/{dataSource}?...
 * so they open the study directly.
 */
export function DMPLaunchRedirect({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  const params = new URLSearchParams(search);
  const studyInstanceUIDs = params.get('StudyInstanceUIDs');
  const sessionId = params.get('session_id');
  const workflow = (params.get('workflow') ?? '').toLowerCase();

  // workflow=default + future version means "load vanilla OHIF worklist" — skip DMP redirect
  const isDefaultPreset = isFutureVersion() && workflow === 'default';

  // At worklist root with DMP launch params → redirect to viewer (unless default preset on future version)
  const isDMPLaunchToViewer =
    (pathname === '/' || !pathname) && !!sessionId && !!studyInstanceUIDs && !isDefaultPreset;

  useEffect(() => {
    if (!isDMPLaunchToViewer) return;
    const defaultDataSource =
      (typeof window !== 'undefined' && (window as any).config?.defaultDataSourceName) ||
      'aws-healthimaging';
    // location.search already includes leading '?'
    navigate(`viewer/${defaultDataSource}${search}`, { replace: true });
  }, [isDMPLaunchToViewer, search, navigate]);

  if (isDMPLaunchToViewer) return null;
  return <>{children}</>;
}
